import React from 'react';
import { Box, Container } from '@material-ui/core';
import useEagerConnect from '../../hooks/useEagerConnect';
import Footer from '../Footer';
import Nav from '../Nav';

import RedemptionInfo from './RedemptionInfo'

const Page: React.FC = ({ children }) => {

  useEagerConnect();
  return (
    <div style={{ position: 'relative', minHeight: '100vh' }}>
      <Nav />
      <Container maxWidth="lg" style={{ paddingBottom: '5rem' }}>
        {/* <RedemptionInfo /> */}
        <Box mb={8}>{children}</Box>
      </Container>
      <Footer />
    </div>
  );
};


export default Page;
